import styled from 'styled-components/macro';

import * as colors from 'components/common/colorConstants';

export const UpsellIconContainer = styled.div`
  padding: 1px 4px;
  border-radius: 3px;
  margin-right: 5px;
  color: ${colors.white};
  background-color: ${colors.green1};
  font-family: roboto;
  font-style: normal;
  font-size: 8px;
  font-weight: 700;
  white-space: nowrap;
  display: grid;
  place-items: center;
`;
